import { site } from '@panel/commons/helpers';
import * as yup from 'yup';
import { OPTIONAL_ANTIQUITY, OPTIONAL_COVERED_AREA, OPTIONAL_TOTAL_AREA } from './featuresConfig';
import { formatNumberToInt } from '../../../utils/numberFormatHelper';

const portalId = site.id;

const genericFormValidation = yup.object().shape({
  CFT101: yup.number().when('$realEstateTypeId', (realEstateTypeId, schema) => {
    return OPTIONAL_COVERED_AREA[portalId].includes(realEstateTypeId)
      ? schema
          .transform((v, o) => (o === '' ? 0 : formatNumberToInt(o)))
          .min(0, 'professionalPubli.features.area.error.invalid')
          .max(999999999, 'professionalPubli.features.area.error.invalid')
          .nullable()
          .notRequired()
      : schema
          .test({
            name: 'not-empty-string',
            message: 'professionalPubli.features.area.error.empty',
            test: function(value, context) {
              // En algunas versiones, el valor original está disponible en this.options
              const original = context?.originalValue || this?.options?.originalValue;

              // Si no podemos acceder al valor original de ninguna manera,
              // usamos una comprobación alternativa
              if (original === undefined) {
                // Si value es undefined o null, probablemente venga de una cadena vacía
                return value !== undefined && value !== null;
              }

              return original !== '';
            }
          })
          .transform((v, o) => (o === '' ? 0 : formatNumberToInt(o)))
          .min(1, 'professionalPubli.features.area.error.invalid')
          .max(999999999, 'professionalPubli.features.area.error.invalid')
          .required('professionalPubli.features.area.error.empty');
  }),
  CFT5: yup.mixed().when('$realEstateTypeId', (realEstateTypeId, schema) => {
    return OPTIONAL_ANTIQUITY[portalId].includes(realEstateTypeId)
      ? schema.nullable().notRequired()
      : schema
          .nullable()
          .test('is-valid-number', 'professionalPubli.features.antiquity.snack.asistText.outOfRange', value => {
            // Si es null o undefined, pasa la validación
            if (value === null || value === undefined || value === '') {
              return true;
            }
            // Si es un número, valida el rango
            return value >= -1 && value <= 200;
          });
  })
});

const commonTotalAreaValidation = yup.object().when(['$realEstateTypeId', 'CFT101'], (realEstateTypeId, CFT101) => {
  return OPTIONAL_TOTAL_AREA[portalId].includes(realEstateTypeId)
    ? yup
        .number()
        .transform((v, o) => (o === '' ? 0 : formatNumberToInt(o)))
        .min(0, 'professionalPubli.features.area.error.invalid')
        .max(999999999, 'professionalPubli.features.area.error.invalid')
        .nullable()
        .notRequired()
    : yup
        .number()
        .test({
          name: 'not-empty-string',
          message: 'professionalPubli.features.area.error.empty',
          test: function(value, context) {
            // En algunas versiones, el valor original está disponible en this.options
            const original = context?.originalValue || this?.options?.originalValue;

            // Si no podemos acceder al valor original de ninguna manera,
            // usamos una comprobación alternativa
            if (original === undefined) {
              // Si value es undefined o null, probablemente venga de una cadena vacía
              return value !== undefined && value !== null;
            }

            return original !== '';
          }
        })
        .transform((v, o) => (o === '' ? 0 : formatNumberToInt(o)))
        .integer()
        .min(1, 'professionalPubli.features.area.error.invalid')
        .max(999999999, 'professionalPubli.features.area.error.invalid')
        // Se utiliza wording y validacion para -> total > construido de publi particulares ( no definido en prof )
        // .moreThan(CFT101 - 1, 'publisher.step1.module4.area.total.validation')
        .required('professionalPubli.features.area.error.empty');
});

function getCustomFormValidations(siteId = '') {
  const portalValidations = {
    ZPAR: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    ICBR: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    WIBR: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    IWBR: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    '24MX': yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    VAMX: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    UBPE: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    DVPE: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    PLEC: yup.object().shape({
      CFT100: commonTotalAreaValidation
    }),
    CAPA: yup.object().shape({
      CFT100: commonTotalAreaValidation
    })
  };
  return portalValidations[siteId];
}

const featuresStepValidations = genericFormValidation.concat(getCustomFormValidations(portalId));

export { featuresStepValidations };
